import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ExpandableCard;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import Card from '../../../../../../../common/components/shared/Card';
import { jsx } from '@instructure/emotion';
import ExpandButton from '../../../../../../../common/components/shared/ExpandButton';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import PropTypes from 'prop-types';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
export var ExpandableCard = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ExpandableCard = /*#__PURE__*/function (_Component) {
  function ExpandableCard() {
    var _this;
    _classCallCheck(this, ExpandableCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ExpandableCard, [].concat(args));
    _defineProperty(_this, "state", {
      bodyExpanded: false
    });
    _defineProperty(_this, "handleBodyToggle", function () {
      _this.setState({
        bodyExpanded: !_this.state.bodyExpanded
      });
    });
    _defineProperty(_this, "renderGroup", function () {
      var headLine = _this.props.headLine;
      return jsx(Flex, {
        direction: "row",
        alignItems: "start"
      }, jsx(Flex.Item, {
        shouldShrink: true,
        shouldGrow: true,
        margin: "xx-small none none none"
      }, headLine), jsx(Flex.Item, {
        margin: "none none none x-small"
      }, jsx(ExpandButton, {
        onClick: _this.handleBodyToggle,
        title: _this.state.bodyExpanded ? t('collapse group result') : t('expand group result'),
        isExpanded: _this.state.bodyExpanded
      })));
    });
    _defineProperty(_this, "renderBody", function () {
      var _this$props = _this.props,
        content = _this$props.content,
        styles = _this$props.styles;
      var bodyContainer = styles.bodyContainer;
      return jsx(Flex.Item, {
        shouldShrink: true,
        padding: "x-small small x-small small"
      }, jsx("div", {
        css: bodyContainer
      }, content));
    });
    _defineProperty(_this, "render", function () {
      var styles = _this.props.styles;
      var groupWrapper = styles.groupWrapper;
      var bodyExpanded = _this.state.bodyExpanded;
      return jsx("div", {
        css: groupWrapper
      }, jsx(Card, null, jsx(Flex, {
        direction: "column",
        justifyItems: "start"
      }, jsx(Flex.Item, {
        shouldGrow: true,
        shouldShrink: true,
        overflowY: "visible"
      }, jsx(Flex, {
        direction: "column",
        justifyItems: "start"
      }, jsx(Flex.Item, {
        shouldShrink: true,
        padding: "x-small small x-small small",
        overflowY: "hidden"
      }, _this.renderGroup()), bodyExpanded && _this.renderBody())))));
    });
    return _this;
  }
  _inherits(ExpandableCard, _Component);
  return _createClass(ExpandableCard);
}(Component), _defineProperty(_ExpandableCard, "displayName", 'ExpandableCard'), _defineProperty(_ExpandableCard, "componentId", "Quizzes".concat(_ExpandableCard.displayName)), _defineProperty(_ExpandableCard, "propTypes", {
  headLine: PropTypes.node,
  content: PropTypes.node,
  styles: PropTypes.object
}.isRequired), _ExpandableCard)) || _class);